<template>
  <div class="list-wrap">
    <div class="title">
      <div class="name">赛事</div>
      <div class="time">时间</div>
      <div class="team">比分情况</div>
      <div class="num">大局数</div>
      <div class="status">大局获胜情况</div>
    </div>
    <div class="item" v-for="(item, idx) in list" :key="`${idx}`">
      <div class="name">{{ item.league }}</div>
      <div class="time">{{ item.start_time_int | formatDate }}</div>
      <div class="team">
        <div class="home">
          <span>{{ item.home_team_zh }}</span>
          <img :src="item.home_logo" @error="onDotaTeamLogoError" alt="">
        </div>
        <div class="score">{{ item.home_score }} - {{ item.away_score }}</div>
        <div class="away">
          <img  :src="item.away_logo" @error="onDotaTeamLogoError" alt="">
          <span>{{ item.away_team_zh }}</span>
        </div>
      </div>
      <div class="num">BO{{ item.bo }}</div>
      <div class="status">
        <img v-if="item.home_score === item.away_score" src="../../../assets/images/gaming/player-peace-icon.png" alt="">
        <img v-else-if="(item.home_team_id === homeId && item.home_score > item.away_score) || (item.away_team_id === homeId && item.away_score > item.home_score)" src="../../../assets/images/gaming/player-success-icon.png" alt="">
        <img v-else src="../../../assets/images/gaming/player-fail-icon.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: "BigList",
  props: {
    homeId: {
      type: Number
    },
    list: {
      type: Array
    }
  },
  filters: {
    formatDate (val) {
      return dayjs(val * 1000).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="less" scoped>
.list-wrap {
  .title {
    display: flex;
    height: 44px;
    line-height: 44px;
    background: #FFFDE8;
    font-size: 14px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    text-align: center;
  }
  .item {
    display: flex;
    height: 36px;
    align-items: center;
    box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.25);
    text-align: center;
    .team {
      display: flex;
      justify-content: center;
      .home, .away {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 4px;
        img {
          width: 18px;
          height: 18px;
        }
      }
      .home {
        justify-content: end;
      }
      .away {
        justify-content: start;
      }
      .score {
        color: #E65668;
        width: 78px;
        text-align: center;
        line-height: 18px;
        font-size: 14px;
      }
    }
    .status {
      img {
        width: 22px;
        height: 22px;
      }
    }
  }
  .name {
    width: 133px;
  }
  .time {
    width: 133px;
    margin-right: 77px;
  }
  .team {
    width: 264px;
    margin-right: 107px;
  }
  .num {
    width: 78px;
    margin-right: 53px;
  }
  .status {
    width: 90px;
  }
}
</style>